<script>

let active = false;
export let boxOne;
export let boxTwo;


function toggleModal() {
    active = !active;
}

// toggleModal on escape key or click on box-modal__wrapper
document.addEventListener('keydown', function(event) {
    if(event.key === 'Escape') {
        toggleModal();
    }
});

document.addEventListener('click', function(event) {
    if(event.target.classList.contains('box-modal__wrapper')) {
        toggleModal();
    }
});

</script>

<div class="box-modal__trigger" on:click={toggleModal}>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <g id="Icon_feather-info" data-name="Icon feather-info" transform="translate(-2 -2)">
          <path id="Path_36" data-name="Path 36" d="M17,10a7,7,0,1,1-7-7,7,7,0,0,1,7,7Z" fill="none" stroke="#ca1e22" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
          <path id="Path_37" data-name="Path 37" d="M18,20.8V18" transform="translate(-8 -8)" fill="none" stroke="#ca1e22" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
          <path id="Path_38" data-name="Path 38" d="M18,12h0" transform="translate(-8 -4.8)" fill="none" stroke="#ca1e22" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </g>
      </svg>      
    <span>Onze boxen</span>
</div>
<div class="box-modal__wrapper" class:active={active}>
    <div class="box-modal__container">
        <div class="box-modal">
            <div class="box-modal__header">
                <h2 class="box-modal__title">Onze opslagboxen</h2>
                <span class="box-modal__close" type="button" data-close on:click={toggleModal}>
                    <svg class="icon icon--close" viewBox="0 0 24 24">
                        <path d="M12 10.586l-4.95-4.95a1 1 0 0 0-1.414 1.414L10.586 12l-4.95 4.95a1 1 0 1 0 1.414 1.414L12 13.414l4.95 4.95a1 1 0 1 0 1.414-1.414L13.414 12l4.95-4.95a1 1 0 1 0-1.414-1.414L12 10.586z" fill="white"></path>
                    </svg>
                </span>
            </div>
            <div class="box-modal__body">
                <div class="box">
                    <h3 class="alt-typo">{boxOne.naam}</h3>
                    <img src="{boxOne.afbeelding.url}" alt="{boxOne.afbeelding.alt}">
                    {@html boxOne.tekst}
                </div>
                <div class="box">
                    <h3 class="alt-typo">{boxTwo.naam}</h3>
                    <img src="{boxTwo.afbeelding.url}" alt="{boxTwo.afbeelding.alt}">
                    {@html boxTwo.tekst}
                </div>
            </div>
        </div>
    </div>
</div>

<style>

h2 {
    font-size: 32px;
    font-weight: 700;
    text-align: center;
    margin: 20px 0;
}
.box-modal__trigger {
    margin-top: 15px;
    display: flex;
    align-items: center;
    gap: 10px;
}
h3.alt-typo {
    font-size: 24px;
    font-weight: 700;
    font-family: "Kalam";
    text-align: center;
}
.box-modal__trigger span {
    font-size: 18px;
    font-weight: 700;
    color: #ca1e22;
    cursor: pointer;
}
.box-modal__trigger:hover span {
    text-decoration: underline;
}
.box {
    height: 100%;
}

.box-modal__wrapper {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,.5);
    display: none;
    align-items: center;
    justify-content: center;
    padding: 10px;
}

.box-modal__wrapper.active {
    display: flex;
}

.box-modal__container {
    position: relative;
    width: 100%;
    max-width: 950px;
    padding: 35px;
    background: white;
    border-radius: 15px;
}

.box-modal__body {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}
@media screen and (max-width: 900px) {
    .box-modal__body {
        max-height: 500px;
        overflow-y: scroll;
        grid-template-columns: 1fr;
    }
}

.box-modal__close {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 30px;
    height: 30px;
    cursor: pointer;
    border-radius: 30px;
    background: #ca1e22;
}

</style>